import { useMutation } from '@tanstack/react-query';
import { useSharedDataprivacyApi } from 'services';

export const useCollectUserDataAndSendMail = () => {
  const { collectUserDataAndSendMail } = useSharedDataprivacyApi();

  return useMutation({ mutationFn: collectUserDataAndSendMail });
};
